function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}
module.exports = _pipe;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_pipe.js
// module id = 134
// module chunks = 0